/*  Variable
   ========================================================================== */
/*  breakpoint
   ========================================================================== */
/*  Misc
   ========================================================================== */
/*  Section Colors
   ========================================================================== */
/*  The Big Guns
   ========================================================================== */
/*  The Next Wave
   ========================================================================== */
/*  Start Ups
   ========================================================================== */
/*  Future Tech
   ========================================================================== */
/*  Reviewed
   ========================================================================== */
/*  Tried & Tested
   ========================================================================== */
/*  Digital Life
   ========================================================================== */
/*  Other Colors
   ========================================================================== */
/*  Generic Colors
   ========================================================================== */
/*  Article Body Colors
   ========================================================================== */
/*  Footer
   ========================================================================== */
/*  AMP
   ========================================================================== */
.footer-red[data-v-68eb5994] {
  background: #dc3a35;
  color: #FFFFFF;
}
.footer-red .logo-box[data-v-68eb5994], .footer-red .logo-header[data-v-68eb5994] {
    cursor: pointer;
}
.footer-red .logo-box .icon path[data-v-68eb5994], .footer-red .logo-header .icon path[data-v-68eb5994] {
      fill: #FFFFFF;
}
.footer-red .logo-header[data-v-68eb5994] {
    height: 1.5rem;
    width: 7.5rem;
    /* Mobile breakpoints */
}
@media (min-width: 1024px) {
.footer-red .logo-header[data-v-68eb5994] {
        display: inline-block;
}
}
.footer-red .unboxing-china[data-v-68eb5994] {
    display: inline-block;
    color: #FFFFFF;
    font-size: 1rem;
    font-weight: 600;
    vertical-align: super;
    text-transform: uppercase;
    display: block;
    padding-top: 1.6875rem;
    /* Mobile breakpoints */
}
.footer-red .unboxing-china[data-v-68eb5994]::before {
      content: " ";
      position: absolute;
      left: 50%;
      -webkit-transform: translateX(-62px);
          -ms-transform: translateX(-62px);
              transform: translateX(-62px);
      margin-top: -0.875rem;
      border-top: 1px solid #FFAA9A;
      border-bottom: 1px solid #FFAA9A;
      padding-top: 0.125rem;
      padding-left: 7.75rem;
}
@media (min-width: 1024px) {
.footer-red .unboxing-china[data-v-68eb5994] {
        font-size: 1.25rem;
}
.footer-red .unboxing-china[data-v-68eb5994]::before {
          padding-left: 9.6875rem;
          -webkit-transform: translateX(-77.5px);
              -ms-transform: translateX(-77.5px);
                  transform: translateX(-77.5px);
}
}
.footer-red .social-box[data-v-68eb5994] {
    cursor: pointer;
    background: #FFAA9A;
}
.footer-red .social-box .social-icon path[data-v-68eb5994] {
      fill: #dc3a35;
}
.footer-red hr[data-v-68eb5994] {
    border-color: #FFAA9A;
}
.footer-red .text[data-v-68eb5994] {
    color: #FFAA9A;
}
.footer-dark[data-v-68eb5994] {
  background: #222222;
  color: #FFFFFF;
}
#tech-lift-modal .footer-dark[data-v-68eb5994] {
    padding-top: 1.25rem;
}
#tech-lift-modal .footer-dark .social-box-container[data-v-68eb5994] {
      padding-top: 0;
}
.footer-dark .logo-box .icon path[data-v-68eb5994], .footer-dark .logo-header .icon path[data-v-68eb5994] {
    fill: #FFFFFF;
}
.footer-dark .social-box[data-v-68eb5994] {
    background: #FFAA9A;
}
.footer-dark .social-box .social-icon path[data-v-68eb5994] {
      fill: #FFFFFF;
}
.footer-dark hr[data-v-68eb5994] {
    border-color: #464646;
}
.footer-dark .social-box[data-v-68eb5994] {
    background: #464646;
}
.footer-dark .text[data-v-68eb5994] {
    color: #FFFFFF;
}
.teach-lift-footer[data-v-68eb5994] {
  font-family: "Barlow", sans-serif;
}
.teach-lift-footer .logo-box[data-v-68eb5994] {
    margin: 0 auto;
    width: 3.75rem;
}
.teach-lift-footer .logo-header[data-v-68eb5994] {
    margin: 0 auto;
    width: 7.5rem;
    margin-bottom: 0.375rem;
    /* Mobile breakpoints */
}
@media (min-width: 1024px) {
.teach-lift-footer .logo-header[data-v-68eb5994] {
        width: 6.75rem;
}
}
.teach-lift-footer .banner-padding[data-v-68eb5994] {
    padding-top: 1.25rem;
    border-bottom: 1px solid #FFAA9A;
    padding-bottom: 1.5rem;
    text-align: center;
    /* Mobile breakpoints */
}
@media (min-width: 1024px) {
.teach-lift-footer .banner-padding[data-v-68eb5994] {
        border-bottom: none;
}
}
.teach-lift-footer .social-box-container[data-v-68eb5994] {
    padding-bottom: 0.625rem;
    /* Mobile breakpoints */
}
@media (min-width: 0) and (max-width: 1023px) {
.teach-lift-footer .social-box-container[data-v-68eb5994] {
        padding-top: 1.25rem;
}
}
.teach-lift-footer .social-box[data-v-68eb5994] {
    width: 3.125rem;
    height: 3.125rem;
    margin-left: 0.625rem;
    margin-rigft: 0.625rem;
    /* Mobile breakpoints */
}
.teach-lift-footer .social-box div[data-v-68eb5994] {
      width: 1.3125rem;
      height: 1.3125rem;
      /* Mobile breakpoints */
}
@media (min-width: 1024px) {
.teach-lift-footer .social-box div[data-v-68eb5994] {
          width: 1.5rem;
          height: 1.5rem;
}
}
@media (min-width: 1024px) {
.teach-lift-footer .social-box[data-v-68eb5994] {
        width: 3.75rem;
        height: 3.75rem;
}
}
.teach-lift-footer .social-box--youtube div[data-v-68eb5994] {
      width: 1.5rem;
      /* Mobile breakpoints */
}
@media (min-width: 1024px) {
.teach-lift-footer .social-box--youtube div[data-v-68eb5994] {
          width: 1.8125rem;
}
}
.teach-lift-footer .text[data-v-68eb5994] {
    font-size: 0.75rem;
    text-transform: uppercase;
}
.teach-lift-footer .connect[data-v-68eb5994] {
    font-weight: bold;
    line-height: 1.25rem;
    /* Mobile breakpoints */
}
@media (min-width: 1024px) {
.teach-lift-footer .connect[data-v-68eb5994] {
        font-size: 1rem;
        line-height: 1.625rem;
        padding-top: 2.25rem;
}
}
.teach-lift-footer .topic-list[data-v-68eb5994] {
    padding: 0.625rem;
    font-weight: bold;
}
.teach-lift-footer .topic-list li[data-v-68eb5994] {
      line-height: 1.875rem;
      font-size: 0.875rem;
      padding: 0;
      background: none;
      border: none;
      /* Mobile breakpoints */
}
@media (min-width: 1024px) {
.teach-lift-footer .topic-list li[data-v-68eb5994] {
          font-size: 1rem;
          line-height: 2.25rem;
}
}
.teach-lift-footer hr[data-v-68eb5994] {
    margin: 0;
}
.teach-lift-footer p[data-v-68eb5994] {
    margin: 0;
    padding: 1.25rem;
    font-size: 0.75rem;
    /* Mobile breakpoints */
}
@media (min-width: 1024px) {
.teach-lift-footer p[data-v-68eb5994] {
        font-size: 0.875rem;
}
}
.teach-lift-footer .flex-row a[data-v-68eb5994] {
    color: inherit;
    text-decoration: none;
}



// WEBPACK FOOTER //
// ./components/app-shell/TechLiftFooter.vue